import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../Model/Combo/combo.service';
import { SessionService } from '../../Util/Session/session.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../Model/Common/common.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';

@Component({
  selector: 'app-muster-attendance-emp-wise-summary',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, NgbDropdownModule, NgSelectModule, LoaderComponent],
  providers: [DatePipe],
  templateUrl: './muster-attendance-emp-wise-summary.component.html',
  styleUrl: './muster-attendance-emp-wise-summary.component.scss'
})
export class MusterAttendanceEmpWiseSummaryComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() tableData: any[] = [];
  @Input() Index: number = 0;
  @Input() SiteMasterID: number = 0;
  @Input() MonthYear: any = null;
  @Input() UpdateRecodes = [] as any;
  @Input() IsLocked: boolean = false;
  @Input() SiteName: string = '';
  @Input() CompanyPermiter = {
    IsAttendanceBeforeDaysAllowed: false,
    AttendanceBeforeDays: 0,
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
    IsUpdateDesignationDutyAllowed: false,
    IsAttendanceResetAllowed: false,
    IsAttendanceDeleteAllowed: false,
    IsAttendanceForSameDayAllowed: false,
    TodayDate: null,
    IsRelievingOTDisable: false
  } as any;
  ErrorHighlight = [] as any;
  SummaryData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  user = [] as any;
  AttendanceTypes = [] as any;
  Designations = [] as any;
  Dutys = [] as any;
  Shifts = [] as any;
  ESS_SaveAttendance_OAS = [] as any;
  uniqDD = [] as any;

  Filter = {
    DDEdit: false,
    DesignationMasterID: null,
    DutyMasterID: null,
    ShiftMasterID: null,
  }

  constructor(
    private musterAttendance: MusterAttendanceService,
    private dateFormate: CustomDateParserFormatter,
    protected datePipe: DatePipe,
    private combo: ComboService,
    private session: SessionService,
    protected common: CommonService,
    private modalService: NgbModal,
    private toast: ToastService,
  ) {
    this.user = this.session.GetUserDetails();
    //this.common.getPageRights();
  }

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    ordering: false,
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columnDefs: [
      {
        targets: 0,
        width: '5px',
      },
      {
        targets: 2,
        width: '60px',
      },
    ],
    drawCallback: () => {
      this.bindSelectAllCheckbox();
    },
    columns: [],
  };

  ngOnInit(): void {
    this.ComboLoadAsync('Attendance Type');
  }

  ngOnDestroy(): void {
    if ($.fn.dataTable.isDataTable('#summarydata')) {
      $('#summarydata').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.SummaryData.filter((e: any) => e.selected).forEach((element: any) => {
        element.Dutys = this.Dutys;
        element.Shifts = this.Shifts;

        element.DesignationMasterId = this.Filter.DesignationMasterID;
        element.DutyMasterId = this.Filter.DutyMasterID;
        element.ShiftMasterId = this.Filter.ShiftMasterID;
      });
      this.initializeDataTable('#summarydata', Object.values(this.SummaryData));
    }
    else {
      form.submitted = true;
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.DDEdit) {
        if (this.SummaryData.filter((e: any) => e.IsAttendanceAllowed && e.selected).findIndex((e: any) => (e.ShiftMasterId == 0 || e.ShiftMasterId == '' || e.ShiftMasterId == null) && (e.AttendanceRemark != "" || e.AttendanceRemark != null)) < 0) {
          this.ESS_SaveAttendanceOAS();
        } else {
          this.toast.show({ message: 'Please select shift for all employee who mark attendance or remove attendance.', type: toastTypeEnum.danger });
        }
      } else {
        if (this.UpdateRecodes.filter((e: any) => e.IsUpdate).findIndex((e: any) => (e.ShiftMasterId == 0 || e.ShiftMasterId == '' || e.ShiftMasterId == null) && (e.AttendanceRemark != "" || e.AttendanceRemark != null)) < 0) {
          this.close(true);
        } else {
          this.toast.show({ message: 'Please select shift for all employee who mark attendance or remove attendance.', type: toastTypeEnum.danger });
        }
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_LoadAttendanceOAS() {
    this.isDisabled = true;
    this.SummaryData = [];
    this.uniqDD = [];
    this.musterAttendance.ESS_LoadAttendanceOAS({
      'SelectType': 'DE', SiteId: this.SiteMasterID,
      MonthName: this.dateFormate.fullmonth[this.MonthYear.month - 1], YearName: this.MonthYear.year,
      EmpMasterId: this.tableData[this.Index].EmpMasterId, AttendanceDate: '', DesignationMasterId: this.tableData[this.Index].DesignationMasterId, DutyMasterId: this.tableData[this.Index].DutyMasterId, ShiftMasterId: this.tableData[this.Index].ShiftMasterId,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.SummaryData = response.Table.length > 0 ? response.Table : [];

          this.UpdateRecodes.forEach((element: any) => {
            const index = this.SummaryData.findIndex((e: any) => e.EmpMasterId == element.EmpMasterId && e.DesignationMasterId == element.DesignationMasterId && e.DutyMasterId == element.DutyMasterId && this.convertDateFormate(e.AttendanceDate) == element.AttendanceDate)
            if (index >= 0) {
              this.SummaryData[index].AttendanceRemark = element.AttendanceRemark;
              if (element.ShiftMasterId > 0) {
                this.SummaryData[index].ShiftMasterId = element.ShiftMasterId;
              }
              if (element.OTHours != null && element.OTHours != '') {
                this.SummaryData[index].OTHours = element.OTHours;
              }
              if (element.RelievingHours != null && element.RelievingHours != '') {
                this.SummaryData[index].RelievingHours = element.RelievingHours;
              }
            }
          });

          this.uniqDD = Array.from(new Map(this.SummaryData.map((item: any) => [`${item.DesignationMasterId}-${item.DutyMasterId}`, { DesgnationID: item.DesignationMasterId, DutyID: item.DutyMasterId }])).values());
          this.loadAllShiftsSequentially();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async loadAllShiftsSequentially() {
    if (!this.IsLocked && this.common.PageRight.IsEdit) {
      if (this.Filter.DDEdit) {
        await this.ComboLoadAsync("Designation");
      }
      for (let i = 0; i < this.uniqDD.length; i++) {
        if (this.Filter.DDEdit) {
          await this.ComboLoadAsync("Duty", i);
        }
        await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", i);
      }

      for (let i = 0; i < this.SummaryData.length; i++) {
        try {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, this.SummaryData[i].AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            // if (this.Filter.DDEdit) {
            //   await this.ComboLoadAsync("Duty", i);
            // }
            //await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", i);
            const uniqddindex = this.uniqDD.findIndex((e: any) => e.DesgnationID == this.SummaryData[i].DesignationMasterId && e.DutyID == this.SummaryData[i].DutyMasterId);
            if (uniqddindex >= 0) {
              if (this.Filter.DDEdit) {
                this.SummaryData[i].Dutys = this.uniqDD[uniqddindex].Dutys;
              }
              this.SummaryData[i].Shifts = this.uniqDD[uniqddindex].Shifts;
            }

            if (this.Filter.DDEdit) {
              if (
                this.SummaryData[i].Dutys.findIndex((e: any) => e.DutyMasterID == this.SummaryData[i].DutyMasterId) < 0
              ) {
                this.SummaryData[i].DutyMasterId = null;
              }
            }

            if (
              this.SummaryData[i].Shifts.findIndex((e: any) => e.ShiftMasterID == this.SummaryData[i].ShiftMasterId) < 0
            ) {
              this.SummaryData[i].ShiftMasterId = null;
            }
          }
        } catch (err) {
          console.error('Error loading shift for row', i, err);
        }
      }
    }
    this.initializeDataTable('#summarydata', Object.values(this.SummaryData));
  }

  ComboLoadAsync(Combotype: string, Index = 0, refresh = false): Promise<any> {
    this.isDisabled = true;
    if (Combotype == "Designation") {
      this.Designations = [];
    } else if (Combotype == "Duty" && Index >= 0) {
      this.SummaryData[Index].Dutys = [];
      this.SummaryData[Index].Shifts = [];
    } else if (Combotype == "ShiftLoadBasedOnDesignationDuty" && Index >= 0) {
      this.SummaryData[Index].Shifts = [];
    } else if (Combotype == "Duty" && Index == -1) {
      this.Dutys = [];
      this.Shifts = [];
      this.Filter.DutyMasterID = null;
      this.Filter.ShiftMasterID = null;
    } else if (Combotype == "ShiftLoadBasedOnDesignationDuty" && Index == -1) {
      this.Shifts = [];
      this.Filter.ShiftMasterID = null;
    }

    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        Combotype: Combotype,
        EmpMasterID: this.user.UserId,
        SiteId: this.SiteMasterID,
        //DesignationId: (Combotype == "Attendance Type" || Combotype == "Designation") ? 0 : Index >= 0 ? this.SummaryData[Index].DesignationMasterId : this.Filter.DesignationMasterID,
        //DutyId: (Combotype == "Attendance Type" || Combotype == "Designation" || Combotype == "Duty") ? 0 : Index >= 0 ? this.SummaryData[Index].DutyMasterId : this.Filter.DesignationMasterID,
        DesignationId: (Combotype == "Attendance Type" || Combotype == "Designation") ? 0 : Index >= 0 ? (!refresh && Combotype == "ShiftLoadBasedOnDesignationDuty") ? this.uniqDD[Index].DesgnationID ?? 0 : this.SummaryData[Index].DesignationMasterId : this.Filter.DesignationMasterID,
        DutyId: (Combotype == "Attendance Type" || Combotype == "Designation" || Combotype == "Duty") ? 0 : Index >= 0 ? (!refresh && Combotype == "ShiftLoadBasedOnDesignationDuty") ? this.uniqDD[Index].DutyID ?? 0 : this.SummaryData[Index].DutyMasterId : this.Filter.DutyMasterID,
        'EmpType': 'Front'
      }).subscribe({
        next: (response) => {
          if (Combotype === 'Attendance Type') {
            this.AttendanceTypes = response.ComboLoad;
            this.ESS_LoadAttendanceOAS();
          } else if (Combotype == 'Designation') {
            this.Designations = response.ComboLoad;
          } else if (Combotype == 'Duty') {
            if (Index >= 0) {
              if (!refresh) {
                this.uniqDD[Index].Dutys = response.ComboLoad;
              } else {
                this.SummaryData[Index].Dutys = response.ComboLoad;
                if (
                  this.SummaryData[Index].Dutys.findIndex((e: any) => e.DutyMasterID == this.SummaryData[Index].DutyMasterId) < 0
                ) {
                  this.SummaryData[Index].DutyMasterId = null;
                }else{
                  this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", Index, true);
                }
              }

            } else {
              this.Dutys = response.ComboLoad;
            }
          } else if (Combotype === 'ShiftLoadBasedOnDesignationDuty') {
            if (Index >= 0) {
              if (!refresh) {
                this.uniqDD[Index].Shifts = response.ComboLoad;
              } else {
                this.SummaryData[Index].Shifts = response.ComboLoad;
                if (
                  this.SummaryData[Index].Shifts.findIndex((e: any) => e.ShiftMasterID == this.SummaryData[Index].ShiftMasterId) < 0
                ) {
                  this.SummaryData[Index].ShiftMasterId = null;
                }
              }
            } else {
              this.Shifts = response.ComboLoad;
            }
          }
          if (refresh) {
            this.initializeDataTable('#summarydata', Object.values(this.SummaryData));
          }
          this.isDisabled = false;
          resolve(true); // Resolve after data is loaded
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  initializeDataTable(selector: string, data: any[]) {
    const tableElement = $(selector);

    const scrollTop = tableElement.parent().scrollTop();
    const scrollLeft = tableElement.parent().scrollLeft();

    if ($.fn.dataTable.isDataTable(selector)) {
      tableElement.DataTable().clear().destroy();
      tableElement.find('thead').empty();
      tableElement.find('tbody').empty();
    }

    this.dtOptions.columns = this.getColumns();
    this.dtOptions.createdRow = (row: Node, data: any, index: number) => {
      const $checkbox = $(row).find('.row-checkbox');

      $checkbox.prop('checked', data.selected ?? false);

      $checkbox.off('change').on('change', (event: any) => {
        const isChecked = event.target.checked;
        data.selected = isChecked;
        this.SummaryData[index].selected = isChecked;
      });
    }

    const table = $(selector).DataTable({
      data: data,
      destroy: true,
      ...this.dtOptions
    });

    setTimeout(() => {
      tableElement.parent().scrollTop(scrollTop ?? 0);
      tableElement.parent().scrollLeft(scrollLeft ?? 0);
    }, 0);
  }

  close(flag = false) {
    if (flag) {
      this.activeModal.close(this.UpdateRecodes);
    } else {
      this.activeModal.close([]);
    }
  }

  convertDateFormate(Date: string, WithTime = false) {
    if (!WithTime) {
      return this.datePipe.transform(Date, 'dd MMM yyyy')
    } else {
      return this.datePipe.transform(Date, 'dd MMM yyyy, HH:mm:ss')
    }
  }

  changeEmp(index: number) {
    if (!this.Filter.DDEdit) {
      if (this.Index > 0 && index == -1) {
        this.Index -= 1;
        this.ESS_LoadAttendanceOAS();
      } else if (this.Index < this.tableData.length - 1 && index == 1) {
        this.Index += 1;
        this.ESS_LoadAttendanceOAS();
      }
    }
  }

  UpdateRecode(data: any) {
    const index = this.UpdateRecodes.findIndex((e: any) => e.EmpMasterId == data.EmpMasterId && e.DesignationMasterId == data.DesignationMasterId && e.DutyMasterId == data.DutyMasterId && e.AttendanceDate == this.convertDateFormate(data.AttendanceDate));
    if (index == -1) {
      this.UpdateRecodes.push({
        DailyAttendanceInOutID: data.DailyAttendanceInOutID,
        EmpMasterId: data.EmpMasterId,
        DesignationMasterId: data.DesignationMasterId,
        DutyMasterId: data.DutyMasterId,
        ShiftMasterId: data.ShiftMasterId,
        AttendanceRemark: data.AttendanceRemark,
        AttendanceDate: this.convertDateFormate(data.AttendanceDate),
        OTHours: data.OTHours,
        RelievingHours: data.RelievingHours,
        IsUpdate: true,
        Index: this.Index
      });
    } else if (index >= 0) {
      this.UpdateRecodes[index].AttendanceRemark = data.AttendanceRemark;
      this.UpdateRecodes[index].OTHours = data.OTHours;
      this.UpdateRecodes[index].RelievingHours = data.RelievingHours;
      this.UpdateRecodes[index].ShiftMasterId = data.ShiftMasterId;
      this.UpdateRecodes[index].IsUpdate = true;
    }
  }

  checkboxChanged() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'If Enable desigantion duty all changes reset?';
    modalRef.result.then(result => {
      if (result) {
        this.ESS_LoadAttendanceOAS();
      } else {
        this.Filter.DDEdit = false;
      }
    });
  }

  getColumns(): any[] {
    const columns: any[] = [];
    columns.push(
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true,
      },
    );

    if (this.Filter.DDEdit) {
      columns.push(
        {
          title: `<input type="checkbox" id="selectAllCheckbox">`,
          data: null,
          orderable: false,
          render: (data: any, type: any, row: any, meta: any) => {
            const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
            if ((difDay == 0
              || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
              || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
              && !this.IsLocked && this.common.PageRight.IsEdit
            ) {
              if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
                return `<input type="checkbox" class="row-checkbox" data-row-index="${meta.row}">`;
              } else {
                return ``;
              }
            } else {
              return ``;
            }
          },
        }
      );
    }

    columns.push(
      {
        title: 'Day',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          if (row.AttendanceDate != null && row.AttendanceDate != '')
            return this.convertDateFormate(row.AttendanceDate,);
          else
            return ''
        },
        orderable: true,
      },
      // {
      //   title: 'Designation',
      //   data: 'DesignationName',
      //   orderable: true,
      // },
      {
        title: 'Designation',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (this.Filter.DDEdit && row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
              const selectId = `designations-${meta.row}`;

              const options = (this.Designations ?? []).map((type: any) =>
                `<option value=${type.DesignationMasterID} ${row.DesignationMasterId === type.DesignationMasterID ? 'selected' : ''}>
              ${type.DesignationName}
            </option>`
              ).join('');

              const isSelected = row.DesignationMasterId ? '' : 'selected';

              return `
            <select class="form-select" name="designations-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value=null ${isSelected}>--select--</option>
              ${options}
            </select>
          `;
            } else {
              return row.DesignationName;
            }
          } else {
            return row.DesignationName;
          }
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (this.Filter.DDEdit && rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
              $(td).find('select').on('change', async (e) => {
                rowData.DesignationMasterId = parseInt(e.target.value) || 0;
                await this.ComboLoadAsync("Duty", rowIndex, true);
                this.UpdateRecode(rowData);
              });
            }
          }
        }
      },
      // {
      //   title: 'Duty',
      //   data: 'DutyName',
      //   orderable: true,
      // },
      {
        title: 'Duty',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (this.Filter.DDEdit && row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
              const selectId = `dutys-${meta.row}`;
              const options = (row.Dutys ?? []).map((type: any) =>
                `<option value=${type.DutyMasterID} ${row.DutyMasterId === type.DutyMasterID ? 'selected' : ''}>
              ${type.DutyName}
            </option>`
              ).join('');

              const isSelected = row.DutyMasterId ? '' : 'selected';

              return `
            <select class="form-select" name="dutys-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value=null ${isSelected}>--select--</option>
              ${options}
            </select>
          `;
            } else {
              return row.DutyName;
            }
          } else {
            return row.DutyName;
          }
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (this.Filter.DDEdit && rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
              $(td).find('select').on('change', async (e) => {
                rowData.DutyMasterId = parseInt(e.target.value) || 0;
                await this.ComboLoadAsync("ShiftLoadBasedOnDesignationDuty", rowIndex, true);
                this.UpdateRecode(rowData);
              });
            }
          }
        }
      },
      {
        title: 'Shift',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
              const selectId = `shifts-${meta.row}`;

              const options = (row.Shifts ?? []).map((type: any) =>
                `<option value=${type.ShiftMasterID} ${row.ShiftMasterId === type.ShiftMasterID ? 'selected' : ''}>
                ${type.ShiftTitle}
              </option>`
              ).join('');

              const isSelected = row.ShiftMasterId ? '' : 'selected';

              return `
              <select class="form-select" name="shifts-${meta.row}" id="${selectId}" style="font-size:xx-small">
                <option value=null ${isSelected}>--select--</option>
                ${options}
              </select>
            `;
            } else {
              return row.ShiftTitle;
            }
          } else {
            return row.ShiftTitle;
          }
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
              $(td).find('select').on('change', (e) => {
                rowData.ShiftMasterId = parseInt(e.target.value) || 0;
                this.UpdateRecode(rowData);
              });
            }
          }
        }
      },
      {
        title: 'Status',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
              // Create a unique ID for each select
              const selectId = `attendance-type-${meta.row}`;

              // Generate options HTML
              const options = this.AttendanceTypes.map((type: any) =>
                `<option value="${type.AttendanceType}" ${row.AttendanceRemark === type.AttendanceType ? 'selected' : ''}>
                ${type.AttendanceTypeName}
              </option>`
              ).join('');

              return `
            <select class="form-select" aria-label="AttendanceType" title="AttendanceType"
                  name="attendanceType-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value="" selected>--select--</option>
              ${options}
            </select>
          `;
            } else {
              return row.AttendanceRemark;
            }
          } else {
            return row.AttendanceRemark;
          }
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
          ) {
            if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
              $(td).find('select').on('change', async (e) => {
                rowData.AttendanceRemark = e.target.value;
                if (!this.CompanyPermiter.IsAttendanceForSameDayAllowed && this.common.ToLowerCase(rowData.AttendanceRemark) == 'p') {
                  if (await this.ESS_ValidateSaveAttendanceOAS(this.convertDateFormate(rowData.AttendanceDate) ?? '', rowData.AttendanceRemark, rowData)) {
                    this.UpdateRecode(rowData);
                  } else {
                    rowData.AttendanceRemark = 'A';
                    $(td).find('select').val('A');
                    this.UpdateRecode(rowData)
                  }
                } else {
                  this.UpdateRecode(rowData);
                }
              });
            }
          }
        }
      },
      {
        title: 'InTime',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          if (row.InTime != null && row.InTime != '')
            return this.convertDateFormate(row.InTime, true);
          else
            return '';
        },
        orderable: true,
      }, {
      title: 'OutTime',
      data: null,
      render: (data: any, type: any, row: any, meta: any) => {
        if (row.OutTime != null && row.OutTime != '')
          return this.convertDateFormate(row.OutTime, true);
        else
          return '';
      },
      orderable: true,
    }, {
      title: 'OTHours',
      data: null,
      render: (data: any, type: any, row: any, meta: any) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
            const inputId = `ot-hours-${meta.row}`;
            return `
            <div class="input-group">
              <input type="number" 
                    class="form-control ot-hours-input" 
                    id="${inputId}"
                    value="${row.OTHours || 0}" 
                    min="0"
                    max="24"
                    step="0.5"
                    data-row-id="${meta.row}"
                    placeholder="OT Hours"
                    style="font-size:xx-small">
            </div>
          `;
          } else {
            return row.OTHours || 0;
          }
        } else {
          return row.OTHours || 0;
        }
      },
      orderable: true,
      createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
        const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
        if ((difDay == 0
          || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
          && !this.IsLocked && this.common.PageRight.IsEdit
        ) {
          if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
            const input = $(td).find('.ot-hours-input');

            input.on('change', (event: any) => {
              const value = parseFloat(event.target.value) || 0;

              if (value < 0) {
                event.target.value = '0';
                rowData.OTHours = 0;
              } else if (value > 24) {
                event.target.value = '24';
                rowData.OTHours = 24;
              } else {
                rowData.OTHours = value;
              }
              this.UpdateRecode(rowData);
            });

            input.on('blur', (event: any) => {
              if (event.target.value === '') {
                event.target.value = '0';
                rowData.OTHours = 0;
                this.UpdateRecode(rowData);
              }
            });
          }
        }
      }
    },
      {
        title: 'Relieving Hours',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
            && !this.CompanyPermiter.IsRelievingOTDisable
          ) {
            if (row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
              const inputId = `relieving-hours-${meta.row}`;
              return `
              <div class="input-group">
                <input type="number" 
                      class="form-control relieving-hours-input" 
                      id="${inputId}"
                      value="${row.RelievingHours || 0}" 
                      min="0"
                      max="24"
                      step="0.5"
                      data-row-id="${meta.row}"
                      placeholder="Relieving Hours"
                      style="font-size:xx-small">
              </div>
            `;
            } else {
              return row.RelievingHours || 0;
            }
          } else {
            return row.RelievingHours || 0;
          }
        },
        orderable: true,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, rowData.AttendanceDate);
          $(td).addClass('text-end');
          if ((difDay == 0
            || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
            || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
            && !this.IsLocked && this.common.PageRight.IsEdit
            && !this.CompanyPermiter.IsRelievingOTDisable
          ) {
            if (rowData.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(rowData.AttendanceDate), rowData.JoiningDate, rowData.LeftDate)) {
              const input = $(td).find('.relieving-hours-input');

              input.on('change', (event: any) => {
                const value = parseFloat(event.target.value) || 0;

                if (value < 0) {
                  event.target.value = '0';
                  rowData.RelievingHours = 0;
                } else if (value > 24) {
                  event.target.value = '24';
                  rowData.RelievingHours = 24;
                } else {
                  rowData.RelievingHours = value;
                }
                this.UpdateRecode(rowData);
              });

              input.on('blur', (event: any) => {
                if (event.target.value === '') {
                  event.target.value = '0';
                  rowData.RelievingHours = 0;
                  this.UpdateRecode(rowData);
                }
              });
            }
          }
        }
      }
    );
    return columns;
  }

  bindSelectAllCheckbox() {
    $('#selectAllCheckbox').off('change').on('change', (e: any) => {
      const checked = e.target.checked;
      this.selectAll(checked);
    });
  }

  selectAll(checked: boolean) {
    $('.row-checkbox').prop('checked', checked);
    this.SummaryData.forEach((row: any) => {
      const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, row.AttendanceDate);
      if ((difDay == 0
        || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
        || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
        && !this.IsLocked && this.common.PageRight.IsEdit
      ) {
        if (this.Filter.DDEdit && row.IsAttendanceAllowed && this.CheckJoinLeftDate(this.convertDateFormate(row.AttendanceDate), row.JoiningDate, row.LeftDate)) {
          row.selected = checked;
        }
      }
    });
  }

  ESS_SaveAttendanceOAS() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.ESS_SaveAttendance_OAS = [];
        this.SummaryData.filter((e: any) => e.IsAttendanceAllowed && e.selected).forEach((element: any) => {
          this.ESS_SaveAttendance_OAS.push(
            {
              DailyAttendanceInOutId: element.DailyAttendanceInOutID,
              EmpMasterId: element.EmpMasterId,
              DesignationId: element.DesignationMasterId,
              DutyId: element.DutyMasterId,
              ShiftMasterId: element.ShiftMasterId,
              AttendanceDate: this.convertDateFormate(element.AttendanceDate),
              AttendanceRemark: element.AttendanceRemark,
              BillableOT: element.OTHours,
              NonBillableOT: element.RelievingHours,
            }
          );
        });
        this.musterAttendance.ESS_SaveAttendanceOAS({
          'SelectType': 'i', SiteId: this.SiteMasterID, ESS_SaveAttendance_OAS: this.ESS_SaveAttendance_OAS
        }).subscribe({
          next: (response) => {
            if (response.Error_Code == '755') {
              this.ESS_SaveAttendance_OAS = [];
              this.UpdateRecodes = [];

              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.activeModal.close(null);
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (response.Error_Code == '767') {
                  if (response.table.Table.length > 0) {
                    this.ErrorHighlight = response.table.Table;

                    this.applyErrorHighlightToExistingRows();
                  }
                }
              });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  CheckJoinLeftDate(Day: any, JoiningDate: any, LeftDate: any) {
    return new Date(Day).getTime() >= new Date(JoiningDate).getTime() && (LeftDate == null || new Date(Day).getTime() <= new Date(LeftDate).getTime());
  }

  getDayDifference(d1: string, d2: string): number {
    d2 = this.convertDateFormate(d2) ?? d2;
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    // Reset hours to 0 to avoid time-related issues
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diff = (date2.getTime() - date1.getTime()) / msPerDay;

    return diff; // positive = date2 after date1, negative = date2 before date1
  }

  async ESS_ValidateSaveAttendanceOAS(AttendanceDate: string, AttendanceRemark: string, employee: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_ValidateSaveAttendanceOAS({
        'SelectType': 'AllowAttendanceForSameDay', SiteId: this.SiteMasterID,
        AttendanceDate: AttendanceDate, AttendanceRemark: AttendanceRemark,
        EmpMasterId: employee.EmpMasterId, DailyAttendanceInOutId: employee.DailyAttendanceInOutID
      }).subscribe({
        next: (response) => {
          if (response.Table[0].Column1 == '01') {
            resolve(true);
          } else {
            resolve(false);
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Table2[0].Column1;
            modalRef.componentInstance.Message2 = "Employee <b>" + employee.EmpCode + "-" + employee.FullName + "</b> is already presnet at site <b>" + response.Table[0].SiteCode + "-" + response.Table[0].SiteName + "<b/>. Date: " + AttendanceDate;
            modalRef.result.then((result: any) => { });
          }
        },
        complete: () => { },
        error: (error) => {
          resolve(error);
        },
      });
    });
  }

  applyErrorHighlightToExistingRows(): void {
    const table = $('#summarydata').DataTable();

    table.rows().every((index: number) => {
      const row = table.row(index).node();
      const data = this.SummaryData[index];

      if (row) {
        const hasError = this.ErrorHighlight.some((e: any) =>
          e.EmpMasterId == data.EmpMasterId &&
          e.DesignationMasterID == data.DesignationMasterId &&
          e.DutyMasterID == data.DutyMasterId &&
          e.AttendanceDate == this.convertDateFormate(data.AttendanceDate)
        );

        if (hasError) {
          $(row).addClass('errorHighlight');

          // Use DataTables to set row style
          const table = $('#summarydata').DataTable();
          const rowIndex = table.row(row).index();

          // Force redraw with styles
          $(row).attr('style', 'background-color: #ff000094 !important; color: white !important;');

          // Also style each cell individually
          $(row).find('td').each(function () {
            $(this).css({
              'background-color': '#ff000094',
              'color': 'white'
            });
          });
        }
      }
    });

    // Redraw the table to reflect changes
    table.draw();
  }
}
